import { render, staticRenderFns } from "./exchangeCard.vue?vue&type=template&id=348dacca&"
import script from "./exchangeCard.vue?vue&type=script&lang=js&"
export * from "./exchangeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports